/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';

import WidgetRoot from './components/Widget/WidgetRoot';
import SettingsRoot from './components/Settings/SettingsRoot';
import { create as createFedopsLogger } from '@wix/fedops-logger';
import i18n from './i18n';
import { EDITOR_ROUTE_PATH } from './enums';
import { Provider } from 'react-redux';
import { store } from './store';
import { TPAComponentsProvider } from 'wix-ui-tpa/TPAComponentsConfig';
import { getLocale } from './services/wixServices';

//const locale = window.__LOCALE__;
const locale = getLocale();

// const fedopsLogger = createFedopsLogger('adsense-editor');

// Move the following `appLoaded()` call to the point where your app has fully loaded.
// See https://github.com/wix-private/fed-infra/blob/master/fedops/fedops-logger/README.md
// fedopsLogger.appLoaded();

const Switch = () => {
  return useRoutes([
    {
      path: `${EDITOR_ROUTE_PATH.settings}`,
      element: <SettingsRoot />,
    },
    {
      path: `${EDITOR_ROUTE_PATH.widget}`,
      element: <WidgetRoot />,
    },
  ]);
};

ReactDOM.render(
  <Suspense fallback="...loading">
    <TPAComponentsProvider value={{ mobile: false, rtl: false }}>
      <I18nextProvider i18n={i18n(locale)}>
        <Router>
          <Provider store={store}>
            <Switch />
          </Provider>
        </Router>
      </I18nextProvider>
    </TPAComponentsProvider>
  </Suspense>,
  document.getElementById('root'),
);
